import { useApiPrivateRequest } from "@/shared/hooks/useApi";

export const useDeleteMcpTool = () => {
  const {
    data: isDeleted,
    call,
    isLoading: isDeleting,
    isFailed: isDeleteFailed,
  } = useApiPrivateRequest<boolean>((_) => true);

  const deleteMcpTool = async (toolName: string) => {
    await call(`/llm/mcpTools/${toolName}`, "DELETE");
  };

  return { isDeleted, deleteMcpTool, isDeleting, isDeleteFailed };
};
